'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { IoEllipseSharp, IoCloseSharp } from 'react-icons/io5';
import styles from '../styles/Navbar.module.css';
import { ConnectButton } from './ConnectButton';
import UserAuthStatus from '../../components/UserAuthStatus';
import { useAuth } from '../../context/AuthContext';
import Image from 'next/image';
const Navbar = ({ toggleMenu, isMenuOpen }) => {
  const [currentTime, setCurrentTime] = useState('');
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      setCurrentTime(`${hours}:${minutes}`);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <nav className={styles.nav}>
      <div className={styles.navbar}>
        <div className={styles.logo}>
        <Link href="/">
            <Image 
              src="/GameMax-Logo-Reflect-72dpi-lrg.png"
              alt="GameMax Logo"
              width={250}
              height={100}
            />
          </Link>
        </div>

        <div className={styles.rightSection}>
          <div className={styles.ctas}>
            <div className={styles.buttonWrapper}>
              {isAuthenticated ? (
                <div className={styles.userSection}>
                  <ConnectButton />
                </div>
              ) : (
                <div className={styles.userSection}>
                   <ConnectButton />
                </div>
              )}

              <div 
                className={`${styles.menu} ${isMenuOpen ? styles.active : ''} ${styles.mobileOnly}`}
                onClick={toggleMenu}
              >
                <div className={styles.menuIcon}>
                  <IoCloseSharp />
                </div>
                <p>Menu</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 